import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true
  });
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div ref={ref} className="w-full rounded-2xl border-2 border-bad/30 bg-bad-soft p-4" data-id="element-60" data-mp="2q1wnrexokjl0">
      <p className="flex items-center gap-2 text-left text-[15px] font-bold leading-snug text-bad" data-id="element-61" data-mp="2b8us9sqzoi0x">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-62" data-mp="2g3qj4pkhozcg" />
        Only {SPOTS_LEFT} spots left at the promotional price!
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-63" data-mp="274n1lq0z0s02">
        <motion.div className="flex h-full items-center justify-end rounded-full bg-bad pr-2" initial={{
        width: "0%"
      }} animate={{
        width: inView ? `${filled}%` : "0%"
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-64" data-mp="5bfngjx3ggfr">
          <span className="text-[11px] font-bold text-white" data-id="element-65" data-mp="3dbwmk8xb9qj6">{Math.round(filled)}% claimed</span>
        </motion.div>
      </div>
    </div>;
}